import { ChangeDetectionStrategy, Component, HostBinding, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageLightboxFile {
  url: string;
  fileName: string;
  createdAt: string;
}

@Component({
  selector: 'lohi-image-lightbox',
  templateUrl: './image-lightbox.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageLightboxComponent implements OnInit {
  @HostBinding('class.cursor-move') public drag = true;
  public rotate = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ImageLightboxFile) {}

  public ngOnInit(): void {}

  public rotateClockWise() {
    if (this.rotate === 3) {
      this.rotate = 0;
    } else {
      this.rotate = this.rotate + 1;
    }
  }

  public rotateCounterClockWise() {
    if (this.rotate === 0) {
      this.rotate = 3;
    } else {
      this.rotate = this.rotate - 1;
    }
  }
}
